import angular from 'angular';
import uiRouter from 'angular-ui-router';
import wysiwygComponent from './wysiwyg.component';

let wysiwygModule = angular.module('wysiwyg', [
  uiRouter
])

.component('wysiwyg', wysiwygComponent)

.name;

export default wysiwygModule;
